import { useTranslation } from 'react-i18next';
import { DebriefFactSource } from '@momentum/types';
import confluenceIcon from '@/features/knowledge/assets/confluence.svg';
import { cn } from '@/shared/utils/utils';

type IntegrationIconSource = Exclude<
  DebriefFactSource,
  DebriefFactSource.Manual
>;

interface IntegrationIconProps {
  source: IntegrationIconSource;
  className?: string;
}

export function IntegrationIcon({ source, className }: IntegrationIconProps) {
  const { t } = useTranslation('debriefV2');
  const { src, label } = getSourceConfig(source, t);

  return (
    <img
      src={src}
      alt={label}
      title={label}
      className={cn('h-3.5 w-3.5 shrink-0', className)}
    />
  );
}

function getSourceConfig(
  source: IntegrationIconSource,
  t: ReturnType<typeof useTranslation<'debriefV2'>>['t']
): { src: string; label: string } {
  switch (source) {
    case DebriefFactSource.Jira:
      return { src: '/jira-logo.svg', label: t('gather.factRow.source.jira') };
    case DebriefFactSource.Sharepoint:
      return {
        src: '/sharepoint-logo.svg',
        label: t('gather.factRow.source.sharepoint'),
      };
    case DebriefFactSource.Confluence:
      return {
        src: confluenceIcon,
        label: t('gather.factRow.source.confluence'),
      };
  }
}
